import { render } from "./MatchIndicator.vue?vue&type=template&id=3cf7f516&ts=true"
import script from "./MatchIndicator.vue?vue&type=script&lang=ts"
export * from "./MatchIndicator.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__